import React from 'react';
import { connect } from 'react-redux';
import Feedback from './Feedback';
import Loading from "./Loading";
import { convertTimeframeTitle } from '../redux/FeedbackRedux';

class FeedbackInbox extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        //sync blink animation in feedback history for row and icon inside when high priority
        document.querySelectorAll('.priority-30').forEach(function (e) {
            e.classList.remove("animation-feedback");
            void e.offsetWidth;
            e.classList.add('animation-feedback');

            let iconElement = e.querySelector('.anim-pulse-icon');
            iconElement.classList.remove("anim-pulse-icon");
            void iconElement.offsetWidth;
            iconElement.classList.add('anim-pulse-icon');
        })
        $('[data-toggle="tooltip"]').each(function () {
            jQuery(this).tooltip({ html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });
    }


    render() {
        const hasReferrer =  this.props.state.initial_feedbacks.some(obj => obj.hasOwnProperty('referrer'));

        return (
            <div className="p-2 position-relative feedback-plp-wrapper">
                <Loading location={'feedbackSection'} />
                {!this.props.state.loading && <>
                    {this.props.state.initial_feedbacks.length !== 0 && (
                        <div className='d-none d-xl-flex w-100 mb-1' style={{ paddingLeft: "0.6rem", paddingRight: "10px" }}>
                            <span className='col-1 pl-0'>{__('Submitted By')}</span>

                            {this.props.state.isDashboard  &&
                                <span className='col-1 pl-0'>{__('Location')}</span>
                            }

                            {(this.props.state.businessDepartmentCount > 0 || hasReferrer) &&
                                <span className='col-1 pl-0'>
                                    <span>{__('Department')}{hasReferrer && "/"}</span>
                                    <span className='d-block'>{hasReferrer && __('Origin') }</span>
                                </span>
                            }
                            <span className='col-1 pl-0'>{__('Status')}</span>
                            <span className={this.props.state.isDashboard ? 'col-3 pl-0 feedback-description-label' : 'col-4 pl-0 feedback-description-label'}>{__('Feedback Submitted')}</span>
                            <span className='col-1 pl-0 feedback-chat-activity-label'>{__('Chat Activity')}</span>

                            <span
                                className='col-1 pl-0'
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Shows if customer has requested a response, and what type of response they prefer')}
                            >
                                {__('Requested Response')}
                            </span>

                            <span
                                className='col-1 pl-0'
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Time elapsed since the Feedback OR a chat response was sent without a response from the business')}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clock" viewBox="0 0 16 16"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" /><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" /></svg>
                            </span>

                            <span
                                className='col-1 pl-0'
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Shows the smiley rating (if available)')}
                                style={{ flex: 1 }}
                            >{__('Satisfaction')}</span>

                            <span className='col-1 pl-0'>{__('Date/Time Submitted')}</span>
                        </div>
                    )}

                    {this.props.state.initial_feedbacks && this.props.state.initial_feedbacks.map((fb, index) => {
                        return <Feedback key={index} feedback={fb} />
                    })}

                    {
                        !this.props.state.initial_feedbacks.length ?
                            <div>
                                <p className="text-center mt-3">{__(`No${this.props.state.status !== null && this.props.state.status !== "null" ? ' "' + window.feedbackStatus[this.props.state.status].label + '"' : ""} Feedbacks Found Based on the Above Filter ${this.props.state.query === "" ? "" : `for "${this.props.state.query}" `}(${convertTimeframeTitle(this.props.state.timeframe)})`)}</p>
                            </div>
                            : null
                    }
                </>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FeedbackInbox);
